import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    title = 'app';
    embedded: boolean = false;

    constructor(route: ActivatedRoute) {
        //window.location.search.split('?')[1].split('&').some(x => x == 'ebd=1');
        route.queryParams.subscribe(queryParams => {
            this.embedded = queryParams.ebd == 1;
        });
    }
}
